import { render } from "./AccountInput.vue?vue&type=template&id=6bd6a67a&scoped=true"
import script from "./AccountInput.vue?vue&type=script&lang=js"
export * from "./AccountInput.vue?vue&type=script&lang=js"

import "./AccountInput.vue?vue&type=style&index=0&id=6bd6a67a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd6a67a"]])

export default __exports__